import { Helmet } from "react-helmet";
import "./scrollingHrms.css";
import delyBites from "../../assets/hrmsLogos/Dely Bites.png";
import fitc from "../../assets/hrmsLogos/Fitc.png";
import ganesh from "../../assets/hrmsLogos/Ganesh logo1.png";
import lora from "../../assets/hrmsLogos/Iora.png";
import mallows from "../../assets/hrmsLogos/Mallows.png";
import procure from "../../assets/hrmsLogos/Procure master.png";
import taucies from "../../assets/hrmsLogos/Taucies.png";
import foodcognics from "../../assets/hrmsLogos/foodcognics.png";
import omDance from "../../assets/hrmsLogos/Om dance.png";

const row1 = [
    delyBites,
    fitc,
    ganesh,
    lora,
    mallows,
    procure,
    taucies,
    foodcognics,
    omDance
];

// const row2 = [
//     mallows,
//     procure,
//     taucies,
// ];


const LogoRow = ({ logos, reverse = false }) => {
    const repeatedLogos = Array(4).fill(logos).flat(); 

    return (
        <div className={`logo-track ${reverse ? "reverse" : ""}`}>
            {repeatedLogos.map((logo, i) => (
                <div className="logo-item" key={i}>
                    <img
                        src={logo}
                        alt="Brand logo"
                        loading="lazy"
                        className="border bg-white w-100"
                    />
                </div>
            ))}
        </div>
    );
};


const ScrollingHrms = () => {
    return (
        <>
            <Helmet>
                <title>Why Choose Our HRMS Software | TechCognics</title>
                <meta
                    name="description"
                    content="Discover why businesses choose TechCognics HRMS software."
                />
            </Helmet>

            <div
                className="trusted-business-section"
                style={{ background: "#f8f9fa" }}
            >
                <div className="container text-center mb-4">
                    <div className="feature-heading" style={{ color: '#0F4F93' }}>  Trusted by Leading Businesses in India</div>
                </div>

                <section className="scrolling-logos">
                    <div className="container">
                        <LogoRow logos={row1} />
                        {/* <LogoRow logos={row2} reverse /> */}
                    </div>
                </section>
            </div>

        </>
    );
};

export default ScrollingHrms;


